module.exports = __webpack_public_path__ + "public/img/zuanshi.89e8358f.png";